(function () {
  if (window.__dokuruCardInit) return;
  window.__dokuruCardInit = true;

  var SUCCESS_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M5 12.5l4.5 4.5L19 7" stroke-width="2.5" fill="none"/></svg>';
  var LOADING_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke-width="2" fill="none" opacity="0.4"/><path d="M12 3 a9 9 0 0 1 9 9" stroke-width="2" stroke-linecap="round" fill="none"/></svg>';
  var ERROR_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18" stroke-width="2.5" stroke-linecap="round"/><line x1="18" y1="6" x2="6" y2="18" stroke-width="2.5" stroke-linecap="round"/></svg>';

  function updateCartCounts(cart) {
    document.querySelectorAll('[data-dokuru-cart-count], .cart-count-bubble span, .cart-item-count, [data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  function refreshDrawerAndOpen() {
    return fetch(window.location.pathname + window.location.search, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('cart-drawer');
        var newBubble = doc.querySelector('#cart-icon-bubble');
        var currentDrawer = document.querySelector('cart-drawer');
        var currentBubble = document.querySelector('#cart-icon-bubble');

        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
          currentDrawer.classList.remove('is-empty');
        }
        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        }
        if (currentDrawer && typeof currentDrawer.open === 'function') {
          var trigger = currentBubble || document.querySelector('#cart-icon-bubble');
          currentDrawer.open(trigger);
        }
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-dokuru-card-form]');
    if (!form) return;
    event.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    var originalSvg = btn.innerHTML;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.innerHTML = LOADING_SVG;

    var params = new URLSearchParams(new FormData(form));
    fetch(form.action, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: params.toString(),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data && res.data.description ? res.data.description : 'Cart add failed');
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        btn.innerHTML = SUCCESS_SVG;
        updateCartCounts(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        return refreshDrawerAndOpen().then(function () {
          setTimeout(function () {
            btn.classList.remove('is-success');
            btn.innerHTML = originalSvg;
            btn.disabled = false;
          }, 1100);
        });
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        btn.innerHTML = ERROR_SVG;
        setTimeout(function () {
          btn.classList.remove('is-error');
          btn.innerHTML = originalSvg;
          btn.disabled = false;
        }, 1600);
      });
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-dokuru-atc]');
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id') || btn.dataset.variantId;
    if (!variantId) return;
    event.preventDefault();
    var originalSvg = btn.innerHTML;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.innerHTML = LOADING_SVG;

    var params = new URLSearchParams();
    params.append('id', String(parseInt(variantId, 10)));
    params.append('quantity', '1');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: params.toString(),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed');
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        btn.innerHTML = SUCCESS_SVG;
        updateCartCounts(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));
        return refreshDrawerAndOpen().then(function () {
          setTimeout(function () {
            btn.classList.remove('is-success');
            btn.innerHTML = originalSvg;
            btn.disabled = false;
          }, 1100);
        });
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        btn.innerHTML = ERROR_SVG;
        setTimeout(function () {
          btn.classList.remove('is-error');
          btn.innerHTML = originalSvg;
          btn.disabled = false;
        }, 1600);
      });
  });
})();
